import React from 'react';
import { Route } from 'react-router';
import { Switch } from 'react-router-dom';
import { userHasInventoryEnabledRedir } from '../core/auth';
import InventoryDetailPage from '../views/inventory/containers/InventoryDetailPage';
import InventoryTabs from '../views/inventory/containers/InventoryTabs';

const InventoryRoute = () => {
  return (
    <Switch>
      <Route exact path="/:site/inventory/">
        <InventoryTabs />
      </Route>
      <Route path="/:site/inventory/:inventory">
        <InventoryDetailPage />
      </Route>
    </Switch>
  );
};

export default userHasInventoryEnabledRedir(InventoryRoute);
